import { createSelector } from 'reselect';
import { StoreState } from '../store-interfaces';

const websiteReportSummarySelector = (state: StoreState) =>
  state.websiteReportSummary;

export const trafficLoadedSelector = createSelector(
  [websiteReportSummarySelector],
  item => item.trafficLoaded,
);

export const trafficTotalSelector = createSelector(
  [websiteReportSummarySelector],
  item => item.trafficTotal,
);

export const trafficMonthlySelector = createSelector(
  [websiteReportSummarySelector],
  item => item.trafficMonthly,
);

export const websiteCompetitorsSelector = createSelector(
  [websiteReportSummarySelector],
  item => item.competitors,
);

export const websitetopLandingsSelector = createSelector(
  [websiteReportSummarySelector],
  item => item.topLandings,
);

export const websiteSummarySelector = createSelector(
  [websiteReportSummarySelector],
  item => item.websiteSummary,
);
